import { useEffect, useRef } from 'react';
import { useDisputeFilter, useUserInfo } from 'state';
import { useInternalUsers } from 'state';

export default function useDisputeFilterDefaults() {
    const { 
        setQueue,
        setAssignee, 
        selectedAssignee, 
        selectedQueue 
    } = useDisputeFilter();
    
    const users = useInternalUsers();
    const user = useUserInfo();
    const queueDefaultAppliedRef = useRef(false);
    const assigneeDefaultAppliedRef = useRef(false);
    const hasResolvedUserType = typeof user.isInternalUser === 'boolean';

    useEffect(() => {
        if (queueDefaultAppliedRef.current || !hasResolvedUserType) {
            return;
        }

        if (!user.isInternalUser || selectedQueue || !user.disputeQueueId) {
            queueDefaultAppliedRef.current = true;
            return;
        }

        queueDefaultAppliedRef.current = true;
        setQueue({
            queueId: user.disputeQueueId,
            queueName: '',
            active: true,
        });
    }, [hasResolvedUserType, selectedQueue, setQueue, user.disputeQueueId, user.isInternalUser]);

    useEffect(() => {
        if (assigneeDefaultAppliedRef.current || !hasResolvedUserType) {
            return;
        }

        if (!user.isInternalUser || selectedAssignee) {
            assigneeDefaultAppliedRef.current = true;
            return;
        }

        if (!users.length) {
            return;
        }

        const matchingUser = users.find(u => 
            u?.emailAddress?.toLowerCase() === user?.emailAddress?.toLowerCase()
        );

        assigneeDefaultAppliedRef.current = true;

        if (matchingUser) {
            setAssignee(matchingUser);
        }
    }, [hasResolvedUserType, selectedAssignee, setAssignee, user.emailAddress, user.isInternalUser, users]);
}
